<template>
    <div class="flex order-info" :style="{width: width}">
        <label class="label" v-text="label">订单编号：</label>
        <p class="flex-1 content" v-text="content" :style="{color: color}">RZ123456789</p>
    </div>
</template>

<script>
  export default {
    name: "LabelText",
    props:{
      label: {
        type: String,
        default: ''
      },
      content: {
        type: String,
        default: ''
      },
      color:{
        type: String,
        default: '#333333'
      },
      width:{
        type: String,
        default: '280px'
      }
    }
  }
</script>

<style scoped lang="scss">
    .flex{
        display: flex;
    }
    .flex-1{
        flex: 1;
    }

    .label{
        color: #878B95;
        font-size: 14px;
    }

    .content{
        color: #333333;
        font-size: 14px;
    }

    .order-info{
        width: 280px;
    }
</style>
